export enum AppRoutesEnum {
    BASE = '',
    ERROR = 'error',

    DASHBOARD = '/checkmate/listing',
    LOGIN = '/login',

    CHECKMATE = '/checkmate',
    CKM_LISTING = '/checkmate/listing',
    CKM_SETUP = '/checkmate/setup',
    CKM_DETAILS = '/checkmate/details',
}
